import React, { useContext } from "react"
import HeaderLoggedOut from "./HeaderLoggedOut"
import HeaderLoggedIn from "./HeaderLoggedIn"
import StateContext from "../StateContext"
import HighlightIcon from "@material-ui/icons/Highlight"
function Header(props) {
  const appState = useContext(StateContext)
  return (
    <header>
      <h1>
        <HighlightIcon />
        Keeper
      </h1>
      <div>{appState.loggedIn ? <HeaderLoggedIn addFlashMessage={props.addFlashMessage} setLoggedIn={props.setLoggedIn} /> : <HeaderLoggedOut />}</div>
    </header>
  )
}

export default Header
